module.exports = __webpack_public_path__ + "static/media/euro--blue.dbb9fe67.svg";